var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 800,
    width: 1200,
    viewBox: "-71.22015 -34.451 617.2413 206.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b8",
    stopOpacity: 0.498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f7f7f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd43b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a9fd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(.56254 0 0 .56797 -9.4 -5.305)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    id: "e",
    y2: 137.273,
    x2: 112.031,
    y1: 192.352,
    x1: 150.961
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(.56254 0 0 .56797 -9.4 -5.305)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    id: "d",
    y2: 114.398,
    x2: 135.665,
    y1: 20.604,
    x1: 26.649
  }), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(0 -.2964 1.43676 0 -128.544 150.52)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c",
    id: "f",
    fy: 132.286,
    fx: 61.519,
    r: 29.037,
    cy: 132.286,
    cx: 61.519
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.022 58.668c0-14.562-4.152-22.038-12.457-22.448a23.4 23.4 0 00-9.669 1.589c-2.505.897-4.191 1.784-5.078 2.68v34.759c5.312 3.333 10.03 4.883 14.143 4.64 8.704-.576 13.061-7.643 13.061-21.22zm10.244.604c0 7.398-1.735 13.539-5.224 18.422-3.89 5.527-9.28 8.373-16.17 8.529-5.196.165-10.547-1.462-16.054-4.874v31.59l-8.909-3.177v-70.12c1.462-1.794 3.343-3.334 5.624-4.64 5.303-3.09 11.745-4.679 19.329-4.757l.126.127c6.93-.088 12.272 2.758 16.025 8.529 3.499 5.292 5.253 12.076 5.253 20.371zm54.447 20.732c0 9.923-.994 16.794-2.982 20.615-1.998 3.821-5.8 6.872-11.414 9.143-4.552 1.793-9.474 2.768-14.757 2.934l-1.472-5.614c5.37-.732 9.153-1.463 11.346-2.194 4.318-1.462 7.28-3.703 8.909-6.706 1.306-2.446 1.949-7.115 1.949-14.026v-2.32c-6.092 2.769-12.476 4.143-19.153 4.143-4.386 0-8.256-1.374-11.59-4.142-3.742-3.012-5.614-6.833-5.614-11.463V33.296l8.91-3.05v37.32c0 3.987 1.286 7.058 3.86 9.212 2.572 2.154 5.906 3.187 9.99 3.11 4.084-.089 8.46-1.668 13.11-4.757V31.59h8.908zm34.778 5.731a35.662 35.662 0 01-2.934.127c-5.039 0-8.967-1.199-11.774-3.606-2.798-2.408-4.201-5.732-4.201-9.972v-35.09h-6.102V31.59h6.102V16.707l8.899-3.168V31.59h10.01v5.605h-10.01V72.04c0 3.343.897 5.712 2.69 7.096 1.54 1.14 3.987 1.793 7.32 1.959zm53.941-.731h-8.91V50.617c0-3.5-.818-6.511-2.446-9.026-1.881-2.846-4.493-4.27-7.846-4.27-4.084 0-9.192 2.155-15.323 6.463v41.22h-8.909V2.807L297.908 0v37.439c5.692-4.143 11.91-6.22 18.665-6.22 4.718 0 8.538 1.59 11.463 4.758 2.933 3.167 4.396 7.115 4.396 11.832zm47.351-27.74c0-5.595-1.063-10.215-3.178-13.87-2.514-4.454-6.423-6.803-11.706-7.047-9.767.565-14.64 7.564-14.64 20.976 0 6.15 1.014 11.287 3.06 15.41 2.613 5.253 6.531 7.846 11.756 7.758 9.805-.078 14.708-7.817 14.708-23.227zm9.757.059c0 7.963-2.037 14.591-6.102 19.884-4.474 5.926-10.654 8.899-18.539 8.899-7.817 0-13.909-2.973-18.305-8.9-3.987-5.292-5.975-11.92-5.975-19.883 0-7.486 2.154-13.783 6.462-18.91 4.552-5.439 10.537-8.168 17.935-8.168 7.398 0 13.422 2.73 18.061 8.168 4.309 5.127 6.463 11.424 6.463 18.91zm51.074 27.681h-8.908V48.667c0-3.986-1.2-7.096-3.597-9.337-2.398-2.233-5.595-3.315-9.581-3.227-4.23.078-8.256 1.462-12.077 4.143v44.758h-8.909v-45.86c5.127-3.733 9.845-6.17 14.153-7.31 4.064-1.062 7.651-1.589 10.741-1.589 2.115 0 4.104.205 5.975.614 3.5.81 6.345 2.31 8.539 4.513 2.446 2.437 3.664 5.361 3.664 8.782z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.51 6.398c-4.583.021-8.96.412-12.812 1.094-11.347 2.004-13.407 6.2-13.407 13.937v10.219h26.813v3.406H24.229c-7.793 0-14.616 4.684-16.75 13.594-2.462 10.213-2.571 16.586 0 27.25 1.906 7.938 6.457 13.594 14.25 13.594h9.219v-12.25c0-8.85 7.657-16.657 16.75-16.657h26.78c7.456 0 13.407-6.138 13.407-13.625V21.43c0-7.267-6.13-12.726-13.406-13.938-4.606-.767-9.385-1.115-13.969-1.094zm-14.5 8.219c2.77 0 5.031 2.298 5.031 5.125 0 2.816-2.261 5.093-5.03 5.093-2.78 0-5.032-2.277-5.032-5.093 0-2.827 2.252-5.125 5.031-5.125z",
    fill: "url(#d)",
    transform: "translate(-5.591 -3.262)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.229 35.054V46.96c0 9.231-7.826 17-16.75 17H47.698c-7.336 0-13.407 6.279-13.407 13.625v25.532c0 7.266 6.319 11.54 13.407 13.625 8.487 2.495 16.626 2.946 26.78 0 6.751-1.955 13.407-5.888 13.407-13.625V92.898H61.104v-3.406h40.187c7.793 0 10.697-5.436 13.407-13.594 2.799-8.399 2.68-16.476 0-27.25-1.926-7.757-5.604-13.594-13.407-13.594zM76.166 99.71c2.78 0 5.032 2.278 5.032 5.094 0 2.827-2.252 5.125-5.032 5.125-2.77 0-5.03-2.298-5.03-5.125 0-2.816 2.26-5.094 5.03-5.094z",
    fill: "url(#e)",
    transform: "translate(-5.591 -3.262)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.963 23.648h1.562v-9.796h3.7v-1.168h-8.962v1.168h3.7v9.796m6.647 0h1.335V14.7l2.896 8.946h1.486l3.018-8.916v8.917h1.456V12.684h-1.926l-3.299 9.393-2.813-9.393h-2.153v10.964",
    style: {
      lineHeight: "125%"
    },
    fontWeight: 400,
    fontSize: 15.165,
    fontFamily: "Bitstream Vera Sans",
    fill: "#646464"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.467 132.286a48.948 8.607 0 11-97.896 0 48.948 8.607 0 1197.896 0z",
    transform: "matrix(.73406 0 0 .80952 10.658 23.748)",
    opacity: 0.444,
    fill: "url(#f)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.d21fdceb19f2a8af681cddb7e7b510a5.svg";
export { ForwardRef as ReactComponent };